<template>
  <div class="mso-discount-rule-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "msoDiscountRuleBase",
};
</script>

